import { Component } from '@angular/core';

@Component({
  selector: 'wgc-header-main',
  templateUrl: './header-main.component.html',
  standalone: false
})
export class HeaderMainComponent {

}
